import React from "react";

import {
    trialPeriod,
} from "../../content/tariffs";
import LandingArrowIcon from "../../ui/LandingArrowIcon";

export default function TrialBanner({t}) {
    return (
        <div className="landing-trial">
            <div className="landing-trial__duration">
                <span>
                    {t(
                        "main.landing.tariffs.trial.free"
                    )}
                </span>

                <strong>
                    {t(
                        trialPeriod.durationKey
                    )}
                </strong>
            </div>

            <div className="landing-trial__content">
                <div className="landing-trial__icon">
                    <svg
                        width="26"
                        height="26"
                        viewBox="0 0 28 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                    >
                        <circle
                            cx="14"
                            cy="14"
                            r="10.5"
                            stroke="currentColor"
                            strokeWidth="1.6"
                        />

                        <path
                            d="M14 8.5V14L17.5 16"
                            stroke="currentColor"
                            strokeWidth="1.6"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>

                <div>
                    <h3>
                        {t(
                            trialPeriod.titleKey
                        )}
                    </h3>

                    <p>
                        {t(
                            trialPeriod.descriptionKey
                        )}
                    </p>
                </div>
            </div>

            <a
                href="/register"
                className="landing-trial__button"
            >
                {t(
                    "main.landing.tariffs.trial.action"
                )}

                <LandingArrowIcon/>
            </a>
        </div>
    );
}
